const motorq = {
    title: "Software Engineer Intern",
    company: "Motorq",
    period: "May 2023 - July 2023",
    description: "Worked on moving caching from in-memory to a shared redis cluster. Also, built a developer tool to automate housekeeping tasks on azure."
  };
  
  export default motorq;
  